module.exports = __webpack_public_path__ + "img/event_mb_tab_03.5550cf77.png";